<div class="ui attached segment" appMargin marginT="5">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    <div fxFlex="20" class="wrapped">{{ ip?.ipRange }}</div>
    <div fxFlex="35">
      {{ ip?.reason }}
    </div>
    <div fxFlex="20">
      {{ ip?.createdBy | createdBy }}
    </div>
    <div fxFlex="20">
      {{ ip?.dateCreated | date: "medium" }}
    </div>
    <div fxFlex="5" fxLayoutAlign="end">
      <div
        suiPopup
        [popupInverted]="true"
        popupPlacement="bottom"
        popupText="Whitelist this IP Address"
      >
        <svg
          (click)="whitelistIpAddress.emit(ip)"
          style="cursor: pointer"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="16" cy="16" r="16" fill="#F0F1F8" />
          <path
            d="M15.8465 25C13.7615 24.475 12.0401 23.2786 10.6823 21.4108C9.32448 19.543 8.64588 17.4694 8.64648 15.19V9.7L15.8465 7L23.0465 9.7V15.19C23.0465 17.47 22.3679 19.5439 21.0107 21.4117C19.6535 23.2795 17.9321 24.4756 15.8465 25ZM15.8465 23.11C17.4065 22.615 18.6965 21.625 19.7165 20.14C20.7365 18.655 21.2465 17.005 21.2465 15.19V10.9375L15.8465 8.9125L10.4465 10.9375V15.19C10.4465 17.005 10.9565 18.655 11.9765 20.14C12.9965 21.625 14.2865 22.615 15.8465 23.11Z"
            fill="#219653"
          />
          <path
            d="M17.6875 15.25C17.6875 14.995 17.665 14.7475 17.635 14.5H18.9025C18.9625 14.74 19 14.9913 19 15.25C19 15.3888 18.9887 15.5238 18.97 15.655C19.2287 15.6925 19.4687 15.775 19.69 15.895C19.7275 15.685 19.75 15.4713 19.75 15.25C19.75 13.1875 18.0625 11.5 16 11.5C13.9262 11.5 12.25 13.1875 12.25 15.25C12.25 17.3125 13.9375 19 16 19C16.2212 19 16.435 18.9775 16.645 18.94C16.4669 18.6133 16.374 18.2471 16.375 17.875C16.375 17.7663 16.3862 17.6613 16.4012 17.5563C16.2812 17.7925 16.15 18.0213 16 18.235C15.6887 17.785 15.4375 17.2863 15.2837 16.75H16.6788C16.904 16.3586 17.2426 16.0448 17.65 15.85C17.6725 15.6513 17.6875 15.4525 17.6875 15.25ZM16 12.2613C16.3112 12.7113 16.5625 13.2138 16.7162 13.75H15.2837C15.4375 13.2138 15.6887 12.7113 16 12.2613ZM13.0975 16C13.0375 15.76 13 15.5088 13 15.25C13 14.9913 13.0375 14.74 13.0975 14.5H14.365C14.335 14.7475 14.3125 14.995 14.3125 15.25C14.3125 15.505 14.335 15.7525 14.365 16H13.0975ZM13.405 16.75H14.5C14.6312 17.2188 14.8 17.6688 15.025 18.085C14.342 17.8494 13.7668 17.3754 13.405 16.75ZM14.5 13.75H13.405C13.7646 13.1227 14.3405 12.6481 15.025 12.415C14.8 12.8313 14.6312 13.2813 14.5 13.75ZM16.8775 16H15.1225C15.085 15.7525 15.0625 15.505 15.0625 15.25C15.0625 14.995 15.085 14.7438 15.1225 14.5H16.8775C16.9112 14.7438 16.9375 14.995 16.9375 15.25C16.9375 15.505 16.9112 15.7525 16.8775 16ZM16.9712 12.415C17.6612 12.6513 18.235 13.1275 18.595 13.75H17.4887C17.3714 13.2855 17.1976 12.8372 16.9712 12.415ZM19.9375 17.2188L18.1562 19L17.125 17.875L17.56 17.44L18.1562 18.0363L19.5025 16.69L19.9375 17.2188Z"
            fill="#219653"
          />
        </svg>
      </div>
    </div>
  </div>
</div>
